/*
 * 本人の［2要素認証をやめる］を押したときの、確かめの小窓の文（2026-10-11、W-4）。
 *
 * ■ 文は Gemini が決めたもの（2026-10-11、Q1〜Q4）。言い回しを変えない
 *
 * **4つとも入っているときだけ**小窓が出る（1つでも空なら出さず、小窓なしで解除する。
 * 見出しだけ・ボタンに字が無い小窓を出さないため）。
 *
 * ■ 小窓が足すもの・足さないもの
 *
 * 足すのは「押し間違いで即時に解除されない」ことだけ。本人確認は足さない。
 * 「ログインから15分以内は本人確認を省く・過ぎたらサーバが再認証を求める」という
 * 今の作りは変えていない。
 *
 * ■ 伝えている事実
 *
 * やめると、認証アプリの登録と予備のコードが消える。以後は確認コードなしでログインできる。
 * スマホを買い替えただけなら、やめずに「付け替える」を使う。
 */
export const MFA_DISABLE_CONFIRM = Object.freeze({
  /* 小窓の見出し。 */
  title: '2要素認証の解除',
  /* 小窓の本文。 */
  body: '2要素認証を解除すると、認証アプリの登録と予備のコードが削除されます。次回からはパスワードのみでログインできます。',
  /* 進めるボタン（押すと解除する）。 */
  proceed: '解除する',
  /* やめるボタン（押すと何もせず閉じる）。 */
  cancel: 'キャンセル'
})

/** 小窓を出せるか。4つの文が全部入っているときだけ。 */
export function mfaDisableConfirmReady (texts) {
  return ['title', 'body', 'proceed', 'cancel'].every(key =>
    !!texts && typeof texts[key] === 'string' && texts[key].trim() !== '')
}
